import axiosInstance from '../lib/axios-instance';

export type TOTPRes = {
  error: boolean;
  msg: string;
};

export type TMatchOTP = {
  token: string;
} & TOTPRes;

export const getOTP = async ({
  refundId,
  email,
  reCaptchaToken,
}: {
  refundId?: string;
  email: string;
  reCaptchaToken: string;
}): Promise<TOTPRes> => {
  try {
    if (!refundId) {
      throw new Error('Can not find ID');
    }

    console.log(axiosInstance.defaults.baseURL, refundId);

    const res = await axiosInstance.post(`generateotp/${refundId}`, {
      keyword: email,
      Facilityname: null,
      reCaptchaToken,
    });

    return res.data;
  } catch (error: any) {
    throw error;
  }
};

export const matchOTP = async ({
  refundId,
  otp,
  reCaptchaToken,
}: {
  refundId?: string;
  otp: string;
  reCaptchaToken: string;
}): Promise<TMatchOTP> => {
  if (!refundId) {
    throw new Error('Can not find ID');
  }

  try {
    const res = await axiosInstance.post(`matchotp/${refundId}`, {
      otpdata: otp,
      reCaptchaToken,
    });

    return res.data;
  } catch (error: any) {
    throw error;
  }
};
